import React, { useState, useEffect } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import { API_URLS } from '../Utils/Constants';
import AppNavbar from "../Navbar/Navbar";
import Form from 'react-bootstrap/Form';
import Button from 'react-bootstrap/Button';
import '../Style/AddCampaign.css';

const EditCampaign = () => {
    const [title, setTitle] = useState('');
    const [description, setDescription] = useState('');
    const [status, setStatus] = useState(true); // true para ACTIVE, false para INACTIVE
    const [error, setError] = useState('');
    const navigate = useNavigate();
    const { id } = useParams();

    useEffect(() => {
        const fetchCampaign = async () => {
            try {
                const token = localStorage.getItem('token');
                const response = await fetch(`${API_URLS.BASE_PATH}/api/campaign/${id}`, {
                    method: 'GET',
                    headers: {
                        'Content-Type': 'application/json',
                        'Authorization': `${token}`,
                    }
                });

                const data = await response.json();

                if (response.ok) {
                    setTitle(data.title);
                    setDescription(data.description);
                    setStatus(data.status === 'ACTIVE');
                } else if (response.status === 403 || response.status === 401) {
                    console.error('Token invalido o expirado');
                    localStorage.removeItem('token');
                    navigate('/login');
                } else {
                    setError(data.error || 'Error al cargar la campaña.');
                }
            } catch (error) {
                console.error('Error al cargar la campaña:', error);
                setError('Hubo un error en el servidor.');
            }
        };

        fetchCampaign();
    }, [id]);

    const handleSubmit = async (e) => {
        e.preventDefault();

        if (!title || !description) {
            setError('Por favor, rellena todos los campos requeridos.');
            return;
        }

        const updatedCampaign = {
            title,
            description,
            status: status ? 'ACTIVE' : 'INACTIVE'
        };

        try {
            const token = localStorage.getItem('token');
            const response = await fetch(`${API_URLS.BASE_PATH}/api/update-campaign/${id}`, {
                method: 'PUT',
                headers: {
                    'Content-Type': 'application/json',
                    'Authorization': `${token}`,
                },
                body: JSON.stringify(updatedCampaign)
            });

            const data = await response.json();

            if (response.ok) {
                navigate('/home');
            } else if (response.status === 403 || response.status === 401) {
                console.error('Token invalido o expirado');
                localStorage.removeItem('token');
                navigate('/login');
            } else {
                setError(data.error || 'Error al actualizar la campaña.');
            }
        } catch (error) {
            console.error('Error al actualizar la campaña:', error);
            setError('Hubo un error en el servidor.');
        }
    };

    return (
        <div className="add-campaign-page">
            <AppNavbar />
            <div className="add-campaign-container">
                <Form onSubmit={handleSubmit}>
                    <Form.Group controlId="title" className="mb-3">
                        <Form.Label>Título de la Campaña</Form.Label>
                        <Form.Control
                            type="text"
                            placeholder="Introduce el título"
                            value={title}
                            onChange={(e) => setTitle(e.target.value)}
                        />
                    </Form.Group>

                    <Form.Group controlId="description" className="mb-3">
                        <Form.Label>Descripción de la Campaña</Form.Label>
                        <Form.Control
                            as="textarea"
                            rows={3}
                            placeholder="Introduce la descripción"
                            value={description}
                            onChange={(e) => setDescription(e.target.value)}
                        />
                    </Form.Group>

                    <Form.Group controlId="status" className="mb-3">
                        <Form.Label>Estado de la Campaña</Form.Label>
                        <Form.Check
                            type="switch"
                            id="status-switch"
                            label={status ? 'Activo' : 'Inactivo'}
                            checked={status}
                            onChange={() => setStatus(!status)}
                        />
                    </Form.Group>

                    {error && <p className="text-danger">{error}</p>}

                    <Button variant="primary" type="submit" className="submit-button">
                        Actualizar Campaña
                    </Button>
                </Form>
            </div>
        </div>
    );
};

export default EditCampaign;
